module.exports = __webpack_public_path__ + "img/yeled_haham_no.8d970219.png";